import { render, staticRenderFns } from "./word_redbook.vue?vue&type=template&id=362c8a9f&scoped=true"
import script from "./word_redbook.vue?vue&type=script&lang=js"
export * from "./word_redbook.vue?vue&type=script&lang=js"
import style0 from "./word_redbook.vue?vue&type=style&index=0&id=362c8a9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c8a9f",
  null
  
)

export default component.exports